import { StatusInscription } from '@/enum/StatusInscription';
import { AloAddress, getDefaultAloAddress } from './AloAddress';
import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMedia, getDefaultAloMedia } from './AloMedia';
import { AloPageContent, getDefaultAloPageContent } from './AloPageContent';
import { AloTemplateCours, getDefaultAloTemplateCours } from './AloTemplateCours';
import { AloTemplateHoraire, getDefaultAloTemplateHoraire } from './AloTemplateHoraire';


export interface AloInscription extends AloBase {          
    crsId:number    
    crwId:number|null
    usrId:number
    famId:number
    isnStatus:number    
    isnDatadd:string
    isnDatinscription:string
    isnDatannulation:string
    email:string

}

export const getDefaultAloInscription = ():AloInscription => {
    return {  
        ...getDefaultAloBase(),        
        crsId:0,
        crwId:null,        
        usrId:0,
        famId:0,
        isnStatus:StatusInscription.attente,
        isnDatadd:'',
        isnDatinscription:'',
        isnDatannulation:'',
        email:''
    }
}

export const cleanAloInscription = (inscription:AloInscription) => {
    if(!inscription) return    
    if(!inscription.id) delete inscription.id
    if(!inscription.usrId) delete inscription.usrId
    if(!inscription.crwId) delete inscription.crwId
    
}